import { render, staticRenderFns } from "./GridRowIcon.vue?vue&type=template&id=52f91d3a&"
import script from "./GridRowIcon.vue?vue&type=script&lang=js&"
export * from "./GridRowIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports